import { Middleware } from '@reduxjs/toolkit';
import { setAuth } from './auth-store/auth-store.reducer';
import { setRumUser, clearRumUser } from '../telemetry';

export const telemetryMiddleware: Middleware = (store) => (next) => (action: any) => {
  const result = next(action);

  if (action.type === setAuth.type) {
    const userAttributes = action.payload?.UserAttributes;
    if (userAttributes) {
      const { isMarvin } = store.getState().auth;
      setRumUser({
        id: userAttributes.Id,
        name: userAttributes.Name,
        email: userAttributes.passPhrase,
        role: userAttributes.Role,
        orgShortCode: userAttributes.OrgShortCode,
        regionId: userAttributes.RegionId,
      });
    } else {
      clearRumUser();
    }
  }

  return result;
};

export default telemetryMiddleware;
